import configAppGetters from './getters/configAppGetters';
import configAssetsGetters from './getters/configAssetsGetters';
import configCustomFeaturesGetters from './getters/configCustomFeaturesGetters';
import configLocalizationGetters from './getters/configLocalizationGetters';
import configOverrideThemeGetters from './getters/configOverrideThemeGetters';
import configSettingGetters from './getters/configSettingGetters';
import configUwmGetters from './getters/configUwmGetters';
import {configAppSetters} from './setters/configAppSetters';

const appConfig = {
    ...configAppGetters,
    ...configAppSetters,
    ...configUwmGetters,
    ...configAssetsGetters,
    ...configSettingGetters,
    ...configLocalizationGetters,
    ...configCustomFeaturesGetters,
    ...configOverrideThemeGetters,
};

export default appConfig;
